const API_URL = process.env.REACT_APP_API_URL || "";

export interface PageDuSite {
  slug: string;
  titre: string;
  contenu: string | null;
  updated_at: string | null;
}

export interface Guide {
  id: number;
  titre: string;
  description: string | null;
  youtube_url: string | null;
  pdf_url: string | null;
}

export interface GuidePrincipal {
  titre: string;
  pdf_url: string;
}

async function get<T>(endpoint: string): Promise<T> {
  const response = await fetch(`${API_URL}/pages-du-site${endpoint}`, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Erreur ${response.status} : ${endpoint}`);
  }
  return response.json();
}

export const pagesDuSiteService = {
  getPage: (slug: string) => get<PageDuSite>(`/${slug}`),

  getGuides: () => get<{ data: Guide[] }>("/guides").then((r) => r.data),

  getGuidePrincipal: () =>
    get<{ data: GuidePrincipal | null }>("/guide-principal").then((r) => r.data),

  getFaq: () => get<{ data: string }>("/faq").then((r) => r.data),

  getGlossaire: () => get<{ data: string }>("/glossaire").then((r) => r.data),
};
